<template>
  <div id="app">
    
    <div class="container">
      <vue-page-transition name="fade-in-right">
        <router-view/>
      </vue-page-transition>
    </div>
    <!-- Your customer chat code -->
      <div id="fb-root"></div>
    <div class="fb-customerchat"
      attribution=setup_tool
      page_id="662945694172966"
      theme_color="#04d25a"
      logged_in_greeting="Hi! I am Manas Paul. How can I help you?"
      logged_out_greeting="Hi! I am Manas Paul. How can I help you?">
    </div>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'  // import the CSS transitions you wish to use, in this case we are using `Slide`

export default {
  components:{
   Slide // Register your component
  },
  created() {


  window.fbAsyncInit = function() {
    FB.init({
      xfbml            : true,
      version          : 'v3.3'
    });
  };

  (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'))


}
}
</script>




<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Gothic+A1:400,600,900&display=swap');
body{
  background-color: rgb(255, 255, 255);
  font-family: 'Gothic A1', sans-serif;
}

/* // Scroll bar */
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 0px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #04d25a; 
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #04d25a; 
}

// css
.bm-burger-button {
      position: fixed;
      width: 36px;
      height: 30px;
      left: 36px;
      top: 36px;
      z-index: 1000;
      cursor: pointer;
    }
    .bm-burger-bars {
      background-color: rgb(63, 63, 65);
    }
    .line-style {
      position: absolute;
      height: 20%;
      left: 0;
      right: 0;
    }
    .cross-style {
      position: absolute;
      top: 12px;
      right: 2px;
      cursor: pointer;
    }
    .bm-cross {
      background: #bdc3c7;
    }
    .bm-cross-button {
      height: 24px;
      width: 24px;
    }
    .bm-menu {
      height: 100%; /* 100% Full-height */
      width: 0; /* 0 width - change this with JavaScript */
      position: fixed; /* Stay in place */
      z-index: 1000; /* Stay on top */
      top: 0;
      left: 0;
      background-color: rgb(63, 63, 65); /* Black*/
      overflow-x: hidden; /* Disable horizontal scroll */
      padding-top: 60px; /* Place content 60px from the top */
      transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
    }

    .bm-overlay {
      background: rgba(0, 0, 0, 0.3);
    }
    .bm-item-list {
      color: #b8b7ad;
      margin-left: 10%;
      font-size: 20px;
    }
    .bm-item-list > * {
      display: flex;
      text-decoration: none;
      padding: 0.7em;
    }
    .bm-item-list > * > span {
      margin-left: 10px;
      font-weight: 700;
      color: white
    }

  a:hover{
    
    color: #04d25a!important;
  }
</style>
